export default {
  add_adjustment: {
    description: "Add new adjustment transaction successfully!",
    nativeDescription: "Add new adjustment transaction successfully!",
  },
  import_attendance: {
    description: "Import time attendance data successfully!",
    nativeDescription: "Import dữ liệu công thành công!",
  },
  assign_payroll_template: {
    description: "Assign payroll template successfully!",
    nativeDescription: "Gán bảng lương mẫu cho nhân viên thành công!",
  },
  assign_workshift: {
    description: "Assign working shift successfully!",
    nativeDescription: "Phân ca cho nhân viên thành công!",
  },
  add_employee: {
    description: "Add new employee profile successfully!",
    nativeDescription: "Khởi tạo hồ sơ nhân viên mới thành công!",
  },
  import_employee: {
    description: "Import employee successfully!",
    nativeDescription: "Import dữ liệu nhân viên thành công!",
  },
  update_employee: {
    description: "Update employee profile successfully!",
    nativeDescription: "Cập nhật hồ sơ nhân viên thành công!",
  },
  update_bulk_employee_salary: {
    description: "Import compensation package successfully!",
    nativeDescription: "Import dữ liệu lương thành công!",
  },
  import_leave_data: {
    description: "Import leave data successfully!",
    nativeDescription: "Import dữ liệu nghỉ phép thành công!",
  },
  import_ta_leave_data: {
    description: "Import time attendance data and leave data successfully!",
    nativeDescription: "Import dữ liệu công và nghỉ phép thành công!",
  },
  lock_data: {
    description: "Lock data successfully!",
    nativeDescription: "Chạy khóa dữ liệu thành công!",
  },
  import_ot: {
    description: "Import overtime data successfully!",
    nativeDescription: "Import dữ liệu tăng ca thành công!",
  },
  run_payroll: {
    description: "Great! You have run payroll successfully!",
    nativeDescription: "Tuyệt vời! Bạn đã chạy tính lương thành công!",
  },
  add_salary_advance: {
    description: "Add new salary advance successfully!",
    nativeDescription: "Khởi tạo bảng tạm ứng lương thành công!",
  },
} as const;
